export class ConfirmBoxModel {
    QuestionTitle?: string;
    WithReason?: boolean;
    Reason?: string;
    WithLengthValidation?: boolean;
}
